import { Component } from 'react'
import HttpError from 'src/utils/Http/HttpError'
import PageError from './PageError/PageError'

type State = {
  error: null | Error
}

type Props = {
  children: JSX.Element
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error: Error): void {
    this.setState({ error })
  }

  render(): JSX.Element {
    const { error } = this.state
    const { children } = this.props

    if (error && error instanceof HttpError) {
      return <PageError />
    }

    return children
  }
}

export default ErrorBoundary
